"use strict";
import { __require as e } from "./index.es405.js";
var n, r;
function o() {
  if (r) return n;
  r = 1;
  var i = e();
  return n = Function.prototype.bind || i, n;
}
export {
  o as __require
};
//# sourceMappingURL=index.es325.js.map
